@import "@/stylesheets/fonts.scss";

.routeContent {
  align-items: center;
  font-family: "SegoeUI", "Helvetica Neue", Arial, sans-serif;
  gap: 2.5rem;
}

.routeContent :global(#page-header) {
  margin-bottom: 0;
  width: 100%;
}

.routeContent :global(#page-header) h1 {
  font-family: "Inter", "Helvetica Neue", Arial, sans-serif;
  font-size: 1.625rem;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.0325rem;
}

.error {
  color: var(--pm-red);
  font-family: "SegoeUI", "Helvetica Neue", Arial, sans-serif;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
}

.error:empty {
  display: none;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  margin: 0;
  width: 100%;
}

.documents {
  background: var(--pm-surface);
  border: 1px solid var(--pm-border);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  padding: 1.25rem;
  width: 100%;
}

.document {
  align-items: center;
  color: var(--pm-text-primary);
  display: flex;
  font-family: "Inter", "Helvetica Neue", Arial, sans-serif;
  font-size: 0.9375rem;
  font-weight: 600;
  gap: 1rem;
  justify-content: space-between;
  letter-spacing: -0.02625rem;
  line-height: normal;
  text-decoration: none;
}

.documentItem + .documentItem {
  border-top: 1px solid var(--pm-border);
  margin-top: 1.25rem;
  padding-top: 1.25rem;
}

.document:focus-visible {
  outline: 2px solid var(--pm-blue-strong);
  outline-offset: 0.25rem;
}

.documentLabel {
  flex: 1 1 auto;
  letter-spacing: normal;
}

.documentChevron {
  border-right: 2px solid var(--pm-grey8);
  border-top: 2px solid var(--pm-grey8);
  flex: 0 0 auto;
  height: 0.5rem;
  transform: rotate(45deg);
  width: 0.5rem;
}

.checkboxRow {
  align-items: center;
  color: var(--pm-grey5);
  cursor: pointer;
  display: flex;
  gap: 0.75rem;
  margin: 0;
  width: 100%;
}

.checkbox {
  appearance: none;
  background: var(--pm-white);
  border: 1px solid var(--pm-grey10);
  border-radius: 0.1875rem;
  cursor: pointer;
  flex: 0 0 auto;
  height: 1.125rem;
  margin: 0;
  position: relative;
  width: 1.125rem;
}

.checkbox:checked {
  background: var(--pm-blue-strong);
  border-color: var(--pm-blue-strong);
}

.checkbox:checked::after {
  background-image: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"%3E%3Cpath d="M4.5 9.15L7.35 12L13.5 5.85" stroke="white" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/%3E%3C/svg%3E');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  content: "";
  inset: 0;
  position: absolute;
}

.checkbox:focus-visible {
  outline: 2px solid var(--pm-blue-strong);
  outline-offset: 2px;
}

.checkboxLabel {
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  font-family: "Inter", "Helvetica Neue", Arial, sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: -0.02625rem;
  line-height: 1.125rem;
  min-height: 1.125rem;
}

.submitButton:global(.MuiButton-root) {
  font-family: "Inter", "Helvetica Neue", Arial, sans-serif !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  letter-spacing: -0.02625rem !important;
  line-height: 1.25rem !important;
  width: 100%;
}

:global(.dark),
:global(.theme-dark1) {
  .routeContent :global(#page-header) h1 {
    color: var(--D16, #ededef);
  }

  .documents {
    background: var(--D4, #26262b);
    border-color: var(--D6, #323239);
  }

  .document {
    color: var(--D16, #ededef);
  }

  .documentItem + .documentItem {
    border-top-color: var(--D6, #323239);
  }

  .documentChevron {
    border-right-color: var(--D11, #898994);
    border-top-color: var(--D11, #898994);
  }

  .checkbox {
    background: var(--D4, #26262b);
    border-color: var(--D6, #323239);
  }

  .checkbox:checked {
    background: var(--pm-blue-strong);
    border-color: var(--pm-blue-strong);
  }

  .checkboxLabel {
    color: var(--D11, #898994);
  }
}
